import { Trans, useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import {
  ERunReportQueryParam,
  ESearchStartedVariant,
} from '@/pages/RunReport/types'
import { parseEnumQueryParam } from '@/utils/parseEnumQueryParam'

export const SearchStarted = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const variantParam = parseEnumQueryParam(
    searchParams.get(ERunReportQueryParam.Variant),
    ESearchStartedVariant,
  )
  const variant =
    variantParam === ESearchStartedVariant.AwaitingConsent
      ? ESearchStartedVariant.AwaitingConsent
      : ESearchStartedVariant.Generating

  const titleKey =
    variant === ESearchStartedVariant.AwaitingConsent
      ? 'dashboard.runReport.searchStarted.awaitingConsentTitle'
      : 'dashboard.runReport.searchStarted.generatingTitle'

  const descriptionKey =
    variant === ESearchStartedVariant.AwaitingConsent
      ? 'dashboard.runReport.searchStarted.awaitingConsentDescription'
      : 'dashboard.runReport.searchStarted.generatingDescription'

  const handleGotIt = () => navigate(AppRoutes.dashboard)

  return (
    <WeScreen
      useHeader={false}
      useNextButton={false}
      useSkipButton={false}
      contentClassName="p-0"
    >
      <div className="flex h-full min-h-0 flex-col items-center justify-center gap-6 px-6 py-12 text-center">
        <h2 className="text-[32px] font-medium leading-tight text-neutralColor">
          {t(titleKey)}
        </h2>
        <p className="max-w-xl text-base text-neutralColor80">
          <Trans
            i18nKey={descriptionKey}
            components={{ b: <strong className="font-bold" /> }}
          />
        </p>
        <Button type="button" onClick={handleGotIt} className="mt-2">
          {t('dashboard.runReport.searchStarted.gotIt')}
        </Button>
      </div>
    </WeScreen>
  )
}
